<p-dialog [(visible)]="openDialog" [modal]="true" [draggable]="false" [resizable]="false" #listaArchivos
          [style]="{'width':'80vw'}"
          (onHide)="onHideArchivos()" [header]="'Por favor seleccionar archivo a utilizar'">
    <div class="col-12 p-0">
        <p-table class="w-full" [value]="archivoItems" responsiveLayout="scroll" [rows]="10"
                 [paginator]="true" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true"
                 currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} archivos"
                 [rowHover]="true"
                 styleClass="p-datatable-gridlines p-datatable-sm"
                 [globalFilterFields]="['nombre', 'tipoArchivo', 'estadoArchivo']"
                 [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-columnFilter
                            type="text"
                            field="nombre"
                            placeholder="Filtrar por nombre"
                            ariaLabel="Filtrar por nombre"/>
                    </th>
                    <th>
                        <p-columnFilter
                            type="text"
                            field="tipoArchivo"
                            placeholder="Filtrar por tipo de archivo"
                            ariaLabel="Filtrar por tipo de archivo"/>
                    </th>
                    <th>
                        <p-columnFilter
                            type="text"
                            field="estadoArchivo"
                            placeholder="Filtrar por estado"
                            ariaLabel="Filtrar por estado"/>
                    </th>
                    <th>Acción</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-archivo>
                <tr>
                    <td>
                            <span class="font-bold ml-1">
                                {{ archivo.nombre }}
                            </span>
                        <div class="flex justify-content-end flex-wrap">
                            <div class="flex align-items-center justify-content-center">
                                <p-tag styleClass="text-xs"
                                       icon="pi pi-clock" [value]="archivo.fechaCreacion"
                                       [pTooltip]="'Fecha creacion de archivo'"/>
                            </div>
                        </div>
                    </td>
                    <td>{{ archivo.tipoArchivo }}</td>
                    <td>{{ archivo.estadoArchivo }}</td>
                    <td>
                        <p-checkbox [binary]="true" (onChange)="onCheckboxChange($event, archivo)"
                                    [inputId]="archivo.hash.toString()"
                                    [pTooltip]="'Seleccionar archivo'"
                                    [ngModel]="isArchivoSeleccionado(archivo.hash)">
                        </p-checkbox>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>
